module.exports = __webpack_public_path__ + "img/paper-plane.1555f4fb.svg";